<script setup>
    import {useMindArchives} from '../store/mindarchives';
    import router from '@/router';
    import {ref, onMounted} from 'vue';
    import '../assets/css/main.css';

    const mindArchives = useMindArchives();
    let loadingPrompt = ref("");
    let isLoading = ref(false);
    let keyword = ref("");
    document.body.style.backgroundColor = "black";
    
    async function getArchive() {
        if (!mindArchives.archiveData.id){
            // get path
            mindArchives.archiveData.id = router.currentRoute.value.params.id;
        }
        
        isLoading.value = true;
        loadingPrompt.value = "extrapolating";
        await mindArchives.fetchArchive();  
        isLoading.value = false;
        loadingPrompt.value = "";

    }

    async function unlockContent() {
        if (keyword.value) {
            await mindArchives.unlockContent(keyword.value);
        }
    }

    onMounted(async ()=>{
        await getArchive();
    });

    function goHome() {
        router.push({path: '/'});
    }


</script>

<template>
    <div id="contentapp">
        <div class="logo-hand" v-on:click="goHome">
            <img src="../assets/mnta.png" height="50"/>
        </div>
        {{ loadingPrompt }}

        <div v-if="mindArchives.archiveData.content">
            <h1 class="ttl">
                <pre>{{ mindArchives.archiveData.id }}</pre>
            </h1>
            <div v-if="mindArchives.archiveData.locked && !mindArchives.archiveData.unlockedContent">
                <div class="first-content">
                    <div v-html="mindArchives.archiveData.content">
                    </div>
                </div>
            </div>
            <div v-else-if="!mindArchives.archiveData.locked">
                <div class="first-content">
                    <div v-html="mindArchives.archiveData.content">
                    </div>
                </div>
            </div>
            <div v-else>

            </div>

            
    
            <div v-if="mindArchives.archiveData.locked && !mindArchives.archiveData.unlockedContent">
                <input class="input-text"  type="text" v-model="keyword"/>
                <button v-on:click="unlockContent" class="submit-btn">
                    &#10004;
                </button>
            </div>
            <div v-else>
                <div class="uk-content" v-html="mindArchives.archiveData.unlockedContent"></div>
            </div>
            
        </div>

    </div>
    
</template>

<style scoped>




#contentapp{
    background-color: #000;
    text-align: center;
    margin: 0 0 0 0;
    padding-top: 10px;
    width: 100%;
}

.first-content{
    border: #fff solid 1px;
    padding: 15px;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 15px;
}

.uk-content{
    color: #fff;
}

.ttl{
    color: #fff;
}
</style>